import { render, staticRenderFns } from "./strategicReport.vue?vue&type=template&id=518b6ae2&scoped=true"
import script from "./strategicReport.vue?vue&type=script&lang=js"
export * from "./strategicReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518b6ae2",
  null
  
)

export default component.exports